import { IItem } from '../types';

type ReturnType<T> = T extends (...args: any[]) => infer R ? R : any;
export type ICache = ReturnType<typeof createCache>;

export const createCache = (
  updateCache: (data: IItem[]) => void,
  items: IItem[]
) => ({
  add(newItem: IItem) {
    updateCache([...items, newItem]);
  },
  update(updatedItem: IItem) {
    const allItemIndex = items.findIndex(el => el.id === updatedItem.id);
    updateCache([
      ...items.slice(0, allItemIndex),
      updatedItem,
      ...items.slice(allItemIndex + 1),
    ]);
  },
  delete(item: IItem) {
    updateCache(items.filter(el => el.id !== item.id));
  },
});



// WEBPACK FOOTER //
// ./src/views/Admin/Items/services/cache.ts